import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import HeatmapVM from '../heatmap';
import './zoomPanel.html';
import './zoomPanel.scss';

export interface HeatmapZoomPanelConfig {
    heatmap: HeatmapVM
}

@injectable()
export default class HeatmapZoomPanelVM {
    private heatmap: HeatmapVM

    scale: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) config: HeatmapZoomPanelConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.heatmap = config.heatmap;

        this.scale = this.heatmap.scale.pluck(scale => `${scale.toFixed(1)}x`);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-heatmap__zoom-panel': true
            }
        });
    }

    zoomIn = () => {
        this.heatmap.zoomIn();
    }

    zoomOut = () => {
        this.heatmap.zoomOut();
    }
}